import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const TeamContext = createContext(null);

export const useTeam = () => {
  const context = useContext(TeamContext);
  if (!context) {
    throw new Error('useTeam must be used within TeamProvider');
  }
  return context;
};

export const TeamProvider = ({ children }) => {
  const { user } = useAuth();
  const [teams, setTeams] = useState([]);
  const [currentTeam, setCurrentTeam] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchTeams();
    }
  }, [user]);

  const fetchTeams = async () => {
    try {
      const response = await axios.get(`${API}/teams`, {
        withCredentials: true
      });
      setTeams(response.data);
      
      // Set first team as current if none selected
      if (response.data.length > 0 && !currentTeam) {
        setCurrentTeam(response.data[0]);
      }
    } catch (error) {
      console.error('Failed to fetch teams:', error);
    } finally {
      setLoading(false);
    }
  };

  const switchTeam = (teamId) => {
    const team = teams.find(t => t.id === teamId);
    if (team) {
      setCurrentTeam(team);
      localStorage.setItem('currentTeamId', teamId);
    }
  };

  const refreshTeams = () => {
    fetchTeams();
  };

  return (
    <TeamContext.Provider value={{ teams, currentTeam, switchTeam, loading, refreshTeams }}>
      {children}
    </TeamContext.Provider>
  );
};

export default TeamContext;